module.exports = __webpack_public_path__ + "img/bg-operation-item-2.ada281c6.png";